module.exports = __webpack_public_path__ + "static/img/title_id.4c43809b.png";